/**
 * @generated SignedSource<<8b81a506c35efa107bb6c9f71fdc48a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Znglist_By_Query$variables = {
  id?: string | null | undefined;
};
export type Znglist_By_Query$data = {
  readonly znglistBy: {
    readonly author: {
      readonly node: {
        readonly id: string;
        readonly name: string | null | undefined;
        readonly slug: string | null | undefined;
        readonly username: string | null | undefined;
      };
    } | null | undefined;
    readonly id: string;
    readonly link: string | null | undefined;
    readonly slug: string | null | undefined;
    readonly status: string | null | undefined;
    readonly title: string | null | undefined;
    readonly znglist: {
      readonly form: {
        readonly node: {
          readonly content: string | null | undefined;
          readonly id: string;
          readonly title: string;
        };
      } | null | undefined;
      readonly order: number | null | undefined;
      readonly templateType: string | null | undefined;
      readonly userType: string | null | undefined;
      readonly znglyContents: ReadonlyArray<{
        readonly databaseId?: number;
      } | null | undefined> | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"Znglist_ZnglyContents_Fragment">;
    } | null | undefined;
  } | null | undefined;
};
export type Znglist_By_Query = {
  response: Znglist_By_Query$data;
  variables: Znglist_By_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "NodeWithAuthorToUserConnectionEdge",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        },
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userType",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateType",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Znglist_ZnglistToFormConnectionEdge",
  "kind": "LinkedField",
  "name": "form",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Form",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v6/*: any*/),
        (v13/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "UIPermission",
  "kind": "LinkedField",
  "name": "uiPermission",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mediaItemUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MediaDetails",
    "kind": "LinkedField",
    "name": "mediaDetails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MediaSize",
        "kind": "LinkedField",
        "name": "sizes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceUrl",
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  },
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Znglist_By_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Znglist",
        "kind": "LinkedField",
        "name": "znglistBy",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Znglist_Znglist",
            "kind": "LinkedField",
            "name": "znglist",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Znglist_ZnglyContents_Fragment"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "znglyContents",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/)
                    ],
                    "type": "ZnglyVideo",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v14/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Znglist_By_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Znglist",
        "kind": "LinkedField",
        "name": "znglistBy",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Znglist_Znglist",
            "kind": "LinkedField",
            "name": "znglist",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "znglyContents",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v12/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StatusSettings",
                        "kind": "LinkedField",
                        "name": "statusSettings",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StateWhenApproved",
                            "kind": "LinkedField",
                            "name": "stateWhenApproved",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ApprovedState",
                            "kind": "LinkedField",
                            "name": "approved",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "timestamp",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AiSearchResults",
                        "kind": "LinkedField",
                        "name": "searchResults",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Snippet",
                            "kind": "LinkedField",
                            "name": "snippets",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "snippet",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ExtractiveAnswer",
                            "kind": "LinkedField",
                            "name": "extractiveAnswers",
                            "plural": true,
                            "selections": [
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pageNumber",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ZnglyVideo_Znglycontent",
                        "kind": "LinkedField",
                        "name": "znglyContent",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "aiSummary",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ctaLink",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ctaName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "contentMediaType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "contentLink",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "contentEmbedHtml",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "contentMediaName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MediaItem",
                            "kind": "LinkedField",
                            "name": "contentFile",
                            "plural": false,
                            "selections": (v16/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "featuredImageLink",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MediaItem",
                            "kind": "LinkedField",
                            "name": "featuredImageFile",
                            "plural": false,
                            "selections": (v16/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shortText",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "htmlDesc",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ZnglyVideo_ZnglycontentToFormConnectionEdge",
                            "kind": "LinkedField",
                            "name": "form",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Form",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v6/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "schema",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "uiSchema",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FormMetadata",
                                    "kind": "LinkedField",
                                    "name": "metadata",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "formStyle",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "formTemplate",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "cookieExpiration",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "submitSuccessText",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "marketingConsent",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "password",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "imageUrl",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "ZnglyVideo",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              },
              (v14/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "703918931d1b9919cf897e2ba69b59cd",
    "id": null,
    "metadata": {},
    "name": "Znglist_By_Query",
    "operationKind": "query",
    "text": "query Znglist_By_Query(\n  $id: ID\n) {\n  znglistBy(id: $id) {\n    id\n    author {\n      node {\n        id\n        name\n        username\n        slug\n      }\n    }\n    title\n    link\n    status\n    slug\n    znglist {\n      order\n      userType\n      templateType\n      ...Znglist_ZnglyContents_Fragment\n      znglyContents {\n        __typename\n        ... on ZnglyVideo {\n          databaseId\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      form {\n        node {\n          id\n          title\n          content\n        }\n      }\n    }\n  }\n}\n\nfragment Znglist_ZnglyContents_Fragment on Znglist_Znglist {\n  znglyContents {\n    __typename\n    ... on ZnglyVideo {\n      id\n      databaseId\n      author {\n        node {\n          id\n          name\n          username\n          slug\n        }\n      }\n      title\n      link\n      status\n      statusSettings {\n        status\n        uiPermission {\n          type\n        }\n        stateWhenApproved {\n          status\n          uiPermission {\n            type\n          }\n        }\n        approved {\n          id\n          timestamp\n          user {\n            name\n            id\n          }\n        }\n      }\n      searchResults {\n        snippets {\n          snippet\n        }\n        extractiveAnswers {\n          content\n          pageNumber\n        }\n      }\n      znglyContent {\n        aiSummary\n        ctaLink\n        ctaName\n        contentMediaType\n        contentLink\n        contentEmbedHtml\n        contentMediaName\n        contentFile {\n          mediaItemUrl\n          mediaDetails {\n            sizes {\n              sourceUrl\n              name\n            }\n          }\n          description\n          id\n        }\n        featuredImageLink\n        featuredImageFile {\n          mediaItemUrl\n          mediaDetails {\n            sizes {\n              sourceUrl\n              name\n            }\n          }\n          description\n          id\n        }\n        shortText\n        htmlDesc\n        form {\n          node {\n            id\n            title\n            content\n            schema\n            uiSchema\n            metadata {\n              formStyle\n              formTemplate\n              cookieExpiration\n              submitSuccessText\n            }\n            marketingConsent\n            password\n            imageUrl\n          }\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a05ed43034f98dcf92958bed594497d6";

export default node;
